<!-- The template of the legacy RAS dialog, with a message for a failed read. The hidden table is NOT
     decoration: the PDF reads the image of every QR code from the element `qr-img-<index>` rendered
     here, so its markup must stay as the legacy one. -->
<div mat-dialog-title>
  <h4>{{ 'properties.list.exportRas' | translate }}</h4>
  <div class="text-muted dialog-subtitle">
  </div>
</div>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

    <div class="alert alert-danger" *ngIf="loadErrorKey">{{ loadErrorKey | translate }}</div>

    <div *ngIf="documentArchive.length">{{ 'properties.list.exportRasText' | translate }}</div>

    <div *ngIf="documentArchive.length" style="visibility: hidden; max-height: 2px; overflow: hidden;">
      <table class="table table-borderless table-striped">
        <thead>
          <th>{{ 'properties.documentsPage.docType' | translate }}</th>
          <th>{{ 'properties.structures.structure' | translate }}</th>
          <th>{{ 'common.cta.printQr' | translate }}</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of documentArchive"
            [ngClass]="{'document-wrapper-text-mandatory-added': item.qrcode !== '', 'document-wrapper-text-mandatory-missing': item.qrcode === ''}">
            <td>{{ item.type }}</td>
            <td>{{ item.structureObjectName }}</td>
            <td>
              <div *ngIf="item.qrcode !== '' && !item.reevaluated">
                <qrcode id="qr-img-{{ item.index }}" [qrdata]="item.qrcode" [width]="150" [errorCorrectionLevel]="'H'" [elementType]="'url'"></qrcode>
              </div>
              <div *ngIf="item.qrcode !== '' && item.reevaluated">
                {{ 'properties.ras.legend.reevaluated' | translate }}
              </div>
              <div *ngIf="item.qrcode === ''">
                <span *ngIf="item.urgent">{{ 'properties.ras.legend.urgent' | translate }}</span>
                <span *ngIf="!item.urgent">{{ 'properties.ras.legend.necessary' | translate }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!dialogIsLoading && !loadErrorKey && documentArchive.length === 0">{{ 'properties.list.noExportRas' | translate }}</div>

</mat-dialog-content> <!-- mat-dialog-content -->
<div mat-dialog-actions>
  <div class="row w-100 mt-4">
    <div class="col-12 col-md-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
    <div class="col-12 col-md-6 text-right" *ngIf="documentArchive.length">
      <a mat-button (click)="onExportFile()" mat-raised-button mat-default
        class="ml-3" color="primary">{{ 'properties.dialog.getPdfDocument' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>
